<template>
  <v-toolbar class="toolbar" elevation="0" dense>
    <v-toolbar-title>
      <h4 v-if="selectedPagamentoItensFilterOption === 'todos'">Itens de pagamento</h4>
      <h4 v-else-if="selectedPagamentoItensFilterOption === 'conciliados'">Itens de pagamento conciliados</h4>
      <h4 v-else-if="selectedPagamentoItensFilterOption === 'nao-conciliados'">Itens de pagamento não conciliados</h4>
    </v-toolbar-title>
    <v-spacer />
    <conciliacao-pagamento-itens-menu />
  </v-toolbar>
</template>

<style scoped>
::v-deep .v-toolbar__content {
  padding-left: 0px
}
</style>

<script>
import { mapState } from 'vuex'
import ConciliacaoPagamentoItensMenu from './ConciliacaoPagamentoItensMenu.vue'

export default {
  components: {
    ConciliacaoPagamentoItensMenu
  },
  computed: {
    ...mapState('conciliacao', ['selectedPagamentoItensFilterOption'])
  }
}
</script>
